import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  beta: true,
  version: '0.0.3-beta',
  firebase: {
    projectId: 'relief-daily',
    appId: '1:440309692937:web:d69d58de14d0a2644ed6d8',
    storageBucket: 'relief-daily.appspot.com',
    apiKey: 'AIzaSyCtKSujOMlKdUJc7iisFBHj4V_nvHNNepc',
    authDomain: 'reliefapp.org',
    messagingSenderId: '440309692937',
    measurementId: 'G-LSV11J6V0G',
  },
  features: {
    debugMode: true,
    experimentalFeatures: true,
    analytics: false,
    showBetaWarnings: true
  },
  // Configuración específica para beta
  baseUrl: 'https://beta-reliefapp-2025.web.app',
  apiUrl: 'https://relief-daily.firebaseapp.com'
};